var _a;
import ClientList from "../page/client/List.vue";
import ShopAfterSalesList from '../page/shopAfterSales/List.vue';
import shopNewDemandList from '../page/shopNewDemand/List.vue';
import DemandDetailDialog from '../components/newMassage/DemandDetailDialog.vue';
import DetailRichText from '../page/notify/DetailRichText.vue';
import AccountCheck from '../page/accountcheck/Index.vue';
import ServiceInterface from '../page/serviceInterface/Index.vue';
export var EBusinessType;
(function (EBusinessType) {
    EBusinessType[EBusinessType["Client"] = 120] = "Client";
    EBusinessType[EBusinessType["ShopAfterSales"] = 121] = "ShopAfterSales";
    EBusinessType[EBusinessType["shopNewDemand"] = 122] = "shopNewDemand";
    EBusinessType[EBusinessType["DemandDetail"] = 80] = "DemandDetail";
    EBusinessType[EBusinessType["DetailRichText"] = 160] = "DetailRichText";
    EBusinessType[EBusinessType["AccountCheck"] = 10] = "AccountCheck";
    EBusinessType[EBusinessType["ServiceInterface"] = 93] = "ServiceInterface";
})(EBusinessType || (EBusinessType = {}));
export var EBusinessMsgTypeConfig = (_a = {},
    _a[EBusinessType.Client] = {
        comp: ClientList,
        title: "客户管理"
    },
    _a[EBusinessType.ShopAfterSales] = {
        comp: ShopAfterSalesList,
        title: "售后管理"
    },
    _a[EBusinessType.shopNewDemand] = {
        comp: shopNewDemandList,
        title: "新需求"
    },
    _a[EBusinessType.DemandDetail] = {
        comp: DemandDetailDialog,
        title: "商机详情"
    },
    _a[EBusinessType.DetailRichText] = {
        comp: DetailRichText,
        title: "消息详情"
    },
    _a[EBusinessType.AccountCheck] = {
        comp: AccountCheck,
        title: "客户对账单"
    },
    _a['10_1'] = {
        comp: AccountCheck,
        title: "客户对账单"
    },
    _a[EBusinessType.ServiceInterface] = {
        comp: ServiceInterface,
        title: "接口服务"
    },
    _a);
